import { render, staticRenderFns } from "./ContactDetailPage.vue?vue&type=template&id=40ab2f3c&"
import script from "./ContactDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ContactDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ab2f3c')) {
      api.createRecord('40ab2f3c', component.options)
    } else {
      api.reload('40ab2f3c', component.options)
    }
    module.hot.accept("./ContactDetailPage.vue?vue&type=template&id=40ab2f3c&", function () {
      api.rerender('40ab2f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact-data/ContactDetailPage.vue"
export default component.exports